import firebase from "../../config/firebase";

async function storeContactMeMessage(message) {
  try {
    var ref = firebase.firestore().collection("messages");
    var output = { ok: false, message: "Unexpected Fail in Store Function" };
    await ref
      .add({
        firstName: message.firstName,
        lastName: message.lastName,
        email: message.email,
        occupation: message.occupation,
        subject: message.subject,
        message: message.message,
        termsAndConditionsAndPrivacyPolicy: message.terms,
        termsAndPolicyAgreeTime: new Date()
      })
      .then(() => {
        output = { ok: true, message: "Data Stored" };
      })
      .catch(() => {
        output = { ok: false, message: "Failed to Store Data" };
      });
    return output;
  } catch (error) {
    return { ok: false, message: "Unexpected Fail in Store Function" };
  }
}

export default storeContactMeMessage;
